<template>
  <div>
    <div v-if="bargeCapacityData.length">
      <table-top
        page-size-start
        @fetch="fetchBargeCapacity"
      />
      <data-table
        is-td-static
        :table-header="bargeCapacityHeaders"
        :table-data="bargeCapacityData"
        :sort-by="filter.sort_by"
        :sort-dir="filter.sort_dir"
        body-height="100vh"
        @sort="sort"
      >
        <template #td="{ row, header }">
          {{ putOutOrFormatValue(row[header]) }}
        </template>
      </data-table>
    </div>
    <div v-else>
      <no-data />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import NoData from '@/components/noData'
import TableTop from '@/components/tableTop'
import downloadUtils from '@/utils/downloadUtils'
import { isNumber } from '@/utils/salesPlanUtils'

export default {
  components: {
    DataTable,
    NoData,
    TableTop
  },
  props: {
    dateRange: {
      type: Array,
      default: () => []
    },
    isFetch: {
      type: Boolean,
      default: () => false
    },
    isDownload: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      bargeCapacityHeaders: [
        { key: 'season', label: 'Barge Size (Ton)', sortable: true },
        { key: 'internal_company', label: 'TCM/BEK/IMM/JBG', sortable: true },
        { key: 'third_party_coal', label: '3rd Party Coal', sortable: true },
        { key: 'special_third_party_coal', label: 'BBA/KBM/JHN/IKJ', sortable: true }
      ],
      bargeCapacityData: [],
      filter: {
        sort_by: '',
        sort_dir: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      bargeCapacities: 'BargeCapacity/bargeCapacities',
      bargeCapacityFiles: 'BargeCapacity/bargeCapacityFiles'
    })
  },
  watch: {
    isFetch: {
      handler(val) {
        if (val) {
          this.fetchBargeCapacity()
        }
      }
    },
    isDownload: {
      handler(val) {
        if (val) {
          this.downloadBargeCapacity()
        }
      }
    },
    bargeCapacities: {
      handler(val) {
        if (!this.isEmpty(val)) {
          this.bargeCapacityData = val
        }
      }
    },
    bargeCapacityFiles: {
      handler(val) {
        if (!this.isEmpty(val)) {
          downloadUtils(val, `barge_capacity_${this.dateRange[0]}_${this.dateRange[1]}.xls`)
          this.$store.dispatch('BargeCapacity/resetBargeCapacities')
        }
      }
    }
  },
  methods: {
    async fetchBargeCapacity() {
      if (!this.isDateEmpty()) {
        try {
          await this.$store.dispatch('BargeCapacity/fetchBargeCapacities', {
            start_date: this.moment(this.dateRange[0], ['DD-MMM-YYYY']).format('YYYY-MM-DD'),
            end_date: this.moment(this.dateRange[1], ['DD-MMM-YYYY']).format('YYYY-MM-DD'),
            ...this.filter
          })
          this.$emit('update:isFetch', false)
        } catch (e) {
          this.$emit('update:isFetch', false)
          this.showFailedNotification(this, 'Failed to fetch barge capacity, please try again')
        }
        return
      }

      this.$emit('update:isFetch', false)
      this.showWarningNotification(this, 'Please pick date first')
    },
    async downloadBargeCapacity() {
      if (!this.isDateEmpty()) {
        try {
          await this.$store.dispatch('BargeCapacity/downloadBargeCapacities', {
            start_date: this.moment(this.dateRange[0], ['DD-MMM-YYYY']).format('YYYY-MM-DD'),
            end_date: this.moment(this.dateRange[1], ['DD-MMM-YYYY']).format('YYYY-MM-DD')
          })
          this.$emit('update:isDownload', false)
        } catch (e) {
          this.$emit('update:isDownload', false)
          this.showFailedNotification(this, 'Failed to download barge capacity, please try again')
        }
        return
      }

      this.$emit('update:isFetch', false)
      this.showWarningNotification(this, 'Please pick date first')
    },
    putOutOrFormatValue(value) {
      if (isNumber(value)) {
        return value.toLocaleString('id-ID')
      }
      return `${this.startCase(this.lowerCase(value))} Season`
    },
    sort(sortBy, sortDir) {
      this.filter.sort_by = sortBy
      this.filter.sort_dir = sortDir

      this.fetchBargeCapacity()
    },
    isDateEmpty() {
      return !this.dateRange.length || !this.dateRange[0] || !this.dateRange[1]
    }
  }
}
</script>

<style scoped>

</style>
